import { ComponentChildren, h } from 'preact'

interface DayProps {
  children?: ComponentChildren
  disabled?: boolean
  onClick?: (day: number) => void
  key?: number
  rangeStart?: boolean
  rangeMiddle?: boolean
  rangeEnd?: boolean
  selected?: boolean
  today?: boolean
}

export const Day = ({ children, key, onClick, selected, today, rangeStart, rangeMiddle, rangeEnd, disabled }: DayProps) => {
  let classes = 'a-day'
  if (selected) classes += ' a-day--selected'
  if (today) classes += ' a-day--today'
  if (rangeStart) classes += ' a-day--range-start'
  if (rangeMiddle) classes += ' a-day--range-middle'
  if (rangeEnd) classes += ' a-day--range-end'
  if (disabled) classes += ' a-day--disabled'
  return (
    <div
      className={classes}
      key={key}
      onClick={onClick && Array.isArray(children) ? () => onClick(children[0] as number) : undefined}
    >
      {children}
    </div>
  )
}
